import { NgIf } from "@angular/common";
import { Component } from "@angular/core";
import { TooltipModule } from "primeng-v17/tooltip";
import { environment } from "../../../../environments/environment";
import { SidebarAdditionalComponentService } from "../../../shared/primeng/sidebar-additional-component/sidebar-additional-component.service";
import { SettingsService } from "../../../shared/services/settings.service";
import { TranslateDirective } from "../../../shared/transloco/translate.directive";
import { TranslationProposalService } from "../translationProposal.service";
import { NewUiTranslationProposalButtonComponent } from "./new-ui-translationProposalButton.component";

@Component({
  selector: "app-translation-proposal-button",
  templateUrl: "./translationProposalButton.component.html",
  styleUrl: "./translationProposalButton.component.scss",
  imports: [TranslateDirective, NgIf, TooltipModule],
})
export class TranslationProposalButtonComponent extends NewUiTranslationProposalButtonComponent {
  constructor(
    translationProposalService: TranslationProposalService,
    settingsService: SettingsService,
    additionalComponentService: SidebarAdditionalComponentService
  ) {
    super(translationProposalService, settingsService, additionalComponentService);
    if (!environment.newUI) {
      this.additionalComponentService.registerComponentType(TranslationProposalButtonComponent);
    }
  }
}
